module.exports = __webpack_public_path__ + "img/Ascension Island.1a4235f1.svg";